module.exports = __webpack_public_path__ + "static/media/events.39d9c90e.svg";